import { TaskStatusRef, TaskStatusType } from '@/tracker/types';

export const CLOSED_STATUS_TYPES: TaskStatusType[] = ['done', 'cancelled'];

/** Задача закрыта — по категории статуса, а не по конкретному статусу */
export const isClosedStatus = (status: TaskStatusRef): boolean =>
  CLOSED_STATUS_TYPES.includes(status.type);
